export type ShopCardStat = { icon?: string; label: string; value: string };

export type ShopCardText =
  | { kind: "stats"; stats: ShopCardStat[] }
  | { kind: "line"; icon?: string; main: string; target?: string };

const clean = (text: string | null | undefined) =>
  (text || "").replace(/\s+/g, " ").trim();

/**
 * What an Arena shop card shows from the admin's description. The description is
 * HTML written in the admin panel, sometimes a one-line stat ("+300 Damage on
 * Archer") and sometimes a stats table copied from elsewhere (rows of
 * `.lb-list-item`). It is parsed here and never put on the page, so its own
 * fonts and spacing cannot break the card.
 */
export function summarizeShopDescription(
  description: string | null | undefined
): ShopCardText {
  const doc = new DOMParser().parseFromString(description || "", "text/html");

  const rows = Array.from(doc.querySelectorAll(".lb-list-item"));
  if (rows.length) {
    return {
      kind: "stats",
      stats: rows.map((row) => {
        const valueEl = row.querySelector(".fs-med") || row.lastElementChild;
        const labelEl = row.firstElementChild !== valueEl ? row.firstElementChild : null;
        return {
          icon: row.querySelector("img")?.getAttribute("src") || undefined,
          label: clean(labelEl?.textContent),
          value: clean(valueEl?.textContent),
        };
      }),
    };
  }

  const icon = doc.querySelector("img")?.getAttribute("src") || undefined;
  // "10(+1 Free)" reads better as "10 (+1 Free)".
  const text = clean(doc.body.textContent).replace(/(\S)\(\+/g, "$1 (+");
  // English stats name the troop last: "+300 Damage on Archer".
  const split = text.match(/^(.+?)\s+(on\s+.+)$/i);
  return split
    ? { kind: "line", icon, main: split[1], target: split[2] }
    : { kind: "line", icon, main: text };
}
